import React from "react";
import { useTranslation } from "react-i18next";

export default function LanguageToggle({ className = "" }) {
  const { i18n } = useTranslation();
  const lang = i18n.language?.startsWith("en") ? "en" : "de";

  const set = (l) => {
    i18n.changeLanguage(l);
    try { localStorage.setItem("studioops_lang", l); } catch {}
  };

  return (
    <div
      className={`inline-flex items-center bg-bg-void border border-white/10 rounded-md p-0.5 text-[11px] font-medium ${className}`}
      data-testid="language-toggle"
    >
      <button
        type="button"
        onClick={() => set("de")}
        data-testid="lang-de-button"
        className={`px-2 py-1 rounded-sm transition-colors ${lang === "de" ? "bg-bg-surfaceHover text-ink-primary" : "text-ink-secondary hover:text-ink-primary"}`}
      >
        DE
      </button>
      <button
        type="button"
        onClick={() => set("en")}
        data-testid="lang-en-button"
        className={`px-2 py-1 rounded-sm transition-colors ${lang === "en" ? "bg-bg-surfaceHover text-ink-primary" : "text-ink-secondary hover:text-ink-primary"}`}
      >
        EN
      </button>
    </div>
  );
}
